<script>
	import CreateCarparkForm from "../CreateCarparkForm.svelte";
	export let carParkId;
</script>

<CreateCarparkForm isEdit={carParkId} />
